import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IoMdCheckmark } from 'react-icons/io'
import { useParams } from 'react-router'

export default function MultipleSelectResponseQuestion({ question, setAnswer }) {
  const { lng } = useParams()
  const [selectedResponse, setSelectedResponse] = useState({})
  const { t } = useTranslation()  

  function handleChange(question_id, response_id, isChecked) {
    const updatedSelectedResponse = { ...selectedResponse }

    if (isChecked) {
      updatedSelectedResponse[`${question_id}-${response_id}`] = {
        question_id,
        response_id,
      }
    } else {
      delete updatedSelectedResponse[`${question_id}-${response_id}`]
    }

    setSelectedResponse(updatedSelectedResponse)

    setAnswer((prev) => {
      const existingResponses = prev.responses || []
      const newResponses = Object.values(updatedSelectedResponse)

      // Filter out all responses for this question if none are selected
      const filteredResponses = existingResponses.filter((response) => response.question_id !== question_id)

      // Add new responses if there are any
      if (newResponses.length > 0) {
        return {
          ...prev,
          responses: [...filteredResponses, ...newResponses],
        }
      }

      return {
        ...prev,
        responses: filteredResponses,
      }
    })
  }

  return (
    <div
      key={question.id}
      className="flex flex-col border-2 border-muted-300"
      data-aos={`fade-up`}
      data-aos-delay={100}
    >
      <h4 className="px-4 py-3 font-bold border-b-2 border-muted-300 bg-muted-100">{question[`text_${lng}`]}</h4>
      <div className="flex flex-col gap-1 p-4 pt-2">
        <em className="mb-2 font-semibold text-secondary-600">{t('multiple_choices_note')}</em>
        {question.responses?.map((response) => (
          <div
            key={response.id}
            className="flex items-center gap-4"
          >
            <input
              type="checkbox"
              id={`${question.type}-${question.id}-${response.id}`}
              name={response[`text_${lng}`]}
              className="hidden peer"
              onChange={(e) => handleChange(question.id, response.id, e.target.checked)}
              checked={selectedResponse[`${question.id}-${response.id}`] !== undefined}
            />
            <label
              htmlFor={`${question.type}-${question.id}-${response.id}`}
              className="flex items-center justify-center w-4 h-4 border-2 border-muted-300 bg-muted-100 text-muted-100 peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-checked:text-white"
            >
              <IoMdCheckmark
                size={16}
                strokeWidth={1.2}
              />
            </label>
            <label htmlFor={`${question.type}-${question.id}-${response.id}`}>{response[`text_${lng}`]}</label>
          </div>
        ))}
      </div>
    </div>
  )
}
